import * as React from 'react'
import { withRouter } from 'react-router-dom';
import { useState } from 'react';

import SecondaryMenu from '../shared/SecondaryMenu'
import { IAppPropsWithRoute } from '../../common/types';
import api from '../../store/api';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Table from '@material-ui/core/Table';
import LinearProgress from '@material-ui/core/LinearProgress';
import throttle from 'lodash/throttle';
import eventNames from '../../store/signalr/eventNames';
import { addTaskForEvent, removeTaskForEvent } from '../../store/signalr/tasksForEvents';

interface WardsWidgetProps extends IAppPropsWithRoute {
}

const useStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: 40,
        paddingRight: 40,
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    heading: {
        fontSize: 36,
        padding: theme.spacing(5, 0, 5, 0),
        fontWeight: 900,
    },
    gridStyle: {
        padding: theme.spacing(5, 0, 5, 0)
    },
    searchTextBox: {
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: 0,
            top:4
        },
        height: 44,
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2, 0, 0, 50),
        },
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '44px',
        border: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
    },

    table: {
        minWidth: 650,
    },
    tableRow: {
        cursor: 'pointer'
    },
    ContMain: {
        display: 'flex',
        height: '100%',
        alignItems: 'stretch',
    }
}));

interface Ward {
    wardId: string,
    name: string,
    shortName: string,
    locationName: string,
    deleted: boolean
};

const createSortHandler = (event: any, column: any) => {
    console.log(column);

};

const headCells = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Name', width:'30%' },
    { id: 'shortName', numeric: false, disablePadding: false, label: 'Shortname',width:'30%' },
    { id: 'locationName', numeric: false, disablePadding: false, label: 'LocationName',width:'40%' },
];

const componentTaskId = "wardsWidget";

function WardsWidget(props: WardsWidgetProps): JSX.Element {
    const classes = useStyles();
    const [dense, setDense] = React.useState(false);
    const [orderBy, setOrderBy] = React.useState('name');
    const [order, setOrder] = React.useState('asc');
    const [loading, setLoading] = useState(false);
    const [wardList, setWardList] = useState<Ward[]>([]);
    const [recordCount, setRecordCount] = React.useState(0);
    const [searchText, setSearchText] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const history = useHistory();
    const refOrder = React.useRef('asc');
    const refOrderBy = React.useRef('userCombinedName');
    const refSearchText = React.useRef('');
    const refPage = React.useRef(0);

    const whenRefreshWardsDo = () => getAllWards(refPage.current, refSearchText.current, refOrder.current, refOrderBy.current);

    React.useEffect(() => {
        getAllWards(0, '', 'asc', 'name');
    }, []);

    React.useEffect(() => {
        addTaskForEvent(eventNames.refreshWards, componentTaskId, whenRefreshWardsDo);
        return () => {
            removeTaskForEvent(eventNames.refreshWards, componentTaskId);
        }
    }, [whenRefreshWardsDo]);

    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order;
        refOrderBy.current = orderBy;
    }, [page, searchText, order, orderBy]);


    const getAllWards = React.useMemo(() => throttle(async (updatePageNumber: any, keyword: string, sortOrder: any, sortColumn: any): Promise<void> => {
        try {
            setLoading(true);
            const _res = await api.getWardsWithSearch('searchstr=' + keyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + '&pagesize=10&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder);
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setRecordCount(_res.data.itemsCount);
                if (_res.data.itemsCount > 0 && updatePageNumber >= page) {
                    setWardList(_res.data.model);
                } else if (_res.data.itemsCount > 0 && (page == 0 || page == 1)) {
                    setWardList(_res.data.model);
                } else if (_res.data.itemsCount === 0) {
                    setWardList([]);
                }
            } else {
                setWardList([]);
            }
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
        }
    }, 200), []);

    const handleChangePage = (event: any, newPage: any) => {
        const updatePage = newPage + 1;
        setPage(newPage);
        getAllWards(updatePage, searchText, order, orderBy);
    };

    const createSortHandler = (event: any, column: any) => {
        var order_str = (orderBy == column ? (order === 'asc' ? 'desc' : 'asc') : 'asc');
        setOrder(order_str);
        setOrderBy(column);
        getAllWards(page, searchText, order_str, column);
    }

    const search = async (keyword: string): Promise<void> => {
        setPage(0);
        getAllWards(0, keyword, order, orderBy);
    }

    const searchByEnter = async (event: any): Promise<void> => {
        if (event.key === 'Enter') {
            await search(searchText);
        }
    }
    const onEditClick = (event: any, id: any) => {
        if (id) {

            history.push({
                pathname: '/settings/wards/edit/' + id,
            });
        }
    };

    let filterTimeOut: NodeJS.Timeout;

    const inputChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        clearTimeout(filterTimeOut);
        filterTimeOut=setTimeout(() => {
            setSearchText(e.target.value);
            search(e.target.value);
        }, 100)
    }

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        )
    }

    const addWardClick = (event: any) => {
        history.push({
            pathname: '/settings/wards/add'
        });
    };

    return (
        <React.Fragment>
            <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>

                <div style={{ alignSelf: 'stretch', display: 'flex', }}>
                    <SecondaryMenu selectedmenu='Wards' />
                </div>

                <div style={{ display: 'flex', alignSelf: 'start', width: '100%' }}>
                    <Grid container style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                        <Grid item xs={6} style={{ paddingLeft: 40 }}>
                            <div className={classes.heading}>Wards</div>
                        </Grid>
                        <Grid item container xs={6} justify="flex-end" style={{ paddingRight: 25, paddingTop: 40, paddingBottom: 40 }}>
                           
                            <div style={{display:'flex',}}>
                                <TextField
                                    classes={{ root: classes.searchTextBox }}
                                    InputProps={{
                                        startAdornment: < InputAdornment position="end" >
                                                <SearchIcon />
                                        </InputAdornment>
                                    }}
                                    variant='outlined'
                                    className="searchTxt"
                                    id="standard-adornment-password"
                                    type="text"
                                    onKeyPress={searchByEnter}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => inputChangedHandler(e)}
                                />
                                <Button className="searchBtn" style={{ marginLeft: 20 }} variant="contained" color="primary" onClick={addWardClick}>Add Ward</Button>
                            </div>
                        </Grid>
                        <Grid container item xs={12} justify="flex-end">
                            <TableContainer>
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    aria-label="enhanced table"
                                    size={dense ? 'small' : 'medium'}>

                                    <TableHead>
                                        <TableRow>
                                            {headCells.map((headCell) => (
                                                <TableCell
                                                    key={headCell.id}
                                                    align={headCell.numeric ? 'right' : 'left'}
                                                    width={headCell.width}
                                                    sortDirection={orderBy === headCell.id ? 'asc' : false}>
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? (order === 'asc' ? 'asc' : 'desc') : undefined}
                                                        onClick={(e => createSortHandler(e, headCell.id))}>
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {wardList.length > 0 ?
                                            wardList.map((row, index) => {
                                                return (
                                                    <TableRow
                                                        className={classes.tableRow}
                                                        hover
                                                        onClick={(event) => onEditClick(event, row.wardId)}
                                                        tabIndex={-1}
                                                        key={row.wardId}
                                                        role="checkbox">
                                                        <TableCell align="left">{row.name}</TableCell>
                                                        <TableCell align="left">{row.shortName}</TableCell>
                                                        <TableCell align="left">{row.locationName}</TableCell>
                                                    </TableRow>
                                                );
                                            })
                                            :
                                            <TableRow>
                                                <TableCell align="center" colSpan={5}>No data available</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10]}
                                component="div"
                                count={recordCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                            />
                        </Grid>
                    </Grid>
                </div>
                <div style={{}}>
                    {loading ? <CreateLoadingLine /> : null}
                </div>
            </div>
        </React.Fragment>
    );
}

export default React.memo(withRouter(WardsWidget));